<div class="modal-header">
    <div class="d-flex justify-content-between align-items-start w-100">
        <div>
            <h5 class="modal-title mb-1">{{'shipment.invoice.attachInvoice' | cxTranslate}}</h5>
            <h6 class="text-secondary mb-0">{{ batchData?.formattedNominationNumber || batchData?.batchId || '-- --' }}
            </h6>
        </div>
        <div class="d-flex align-items-center">
            <button type="button" class="close" aria-label="Close" (click)="onClose()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</div>

<div id="loader" *ngIf="enableLoader" class="overlay-loader loading-spinner"></div>

<div class="modal-body d-flex flex-column" style="height: 400px;" *ngIf="!enableLoader">
    <div class="row mb-3">

        <div class="col-md-3 col-sm-12 mb-3 mb-md-0">
            <label class="labelClass small strong text-secondary mb-1">{{'shipment.invoice.vesselName' |
                cxTranslate}}</label>
            <p class="fieldClass mb-0 attach-value">{{ batchData?.vesselName || '-- --' }}</p>
        </div>
        <div class="col-md-4 col-sm-12 mb-3 mb-md-0">
            <label class="labelClass small strong text-secondary mb-1">{{'shipment.invoice.dischargePort' |
                cxTranslate}}</label>
            <p class="fieldClass mb-0 attach-value">{{ batchData?.portName || '-- --' }}</p>
        </div>
        <div class="col-md-5 col-sm-12">
            <label class="labelClass small strong text-secondary mb-1">{{'shipment.invoice.materialName' |
                cxTranslate}}</label>
            <p class="fieldClass mb-0 attach-value">{{ (batchData?.material || '---') || (batchData?.productName ||
                '---') }}</p>
        </div>
    </div>
    <div class="table-responsive mb-3 borderRadius overflow-auto" style="max-height: 300px; overflow-y: auto;">
        <table class="table table-sm mb-0">
            <thead class="bg-secondary text-white">
                <tr>
                    <th class="strong border-0 py-2 text-white">{{'shipment.invoice.invoiceFeeType' |
                cxTranslate}}</th>
                    <th class="strong border-0 py-2 text-white">{{'shipment.invoice.dateSubmitted' |
                cxTranslate}}</th>
                    <th class="strong border-0 py-2 text-white">{{'shipment.invoice.status' |
                cxTranslate}}</th>
                 <th class="strong border-0 py-2 text-white">{{'shipment.invoice.sesStatus' |
                cxTranslate}}</th>
                    <th class="border-0 py-2"></th>
                </tr>
            </thead>
            <tbody *ngIf="portInvoices.length">
                <tr *ngFor="let invoice of portInvoices">
                    <td>{{ invoice?.invoicefeetype || '-- --' }}</td>
                    <td>{{ invoice?.createddate ? transformDate(invoice.createddate) : '-- --' }}</td>
                    <td>
                        <span class="badge text-white"
                        [ngStyle]="{
            'background-color': (invoice?.status | lowercase) === 'success' ? '#28A745' :
                                (invoice?.status | lowercase) === 'rejected' ? '#663366' :
                                (invoice?.status | lowercase) === 'in_progress' ? '#f77f00' :
                                (invoice?.status | lowercase) === 'failure' ? '#dc3545' :
                                '#f77f00',
            'color': '#fff',
            'font-size': '0.85rem',
            'padding': '6px 10px'
        }">
                            {{ invoice?.status || '-- --' }}
                        </span>
                    </td>
                    <td>                        <span class="badge text-white"
                        [ngStyle]="{
            'background-color': (invoice?.sesstatus | lowercase) === 'success' ? '#28A745' :
                                (invoice?.sesstatus | lowercase) === 'rejected' ? '#663366' :
                                (invoice?.sesstatus | lowercase) === 'in_progress' ? '#f77f00' :
                                (invoice?.sesstatus | lowercase) === 'failure' ? '#dc3545' :
                                '#f77f00',
            'color': '#fff',
            'font-size': '0.85rem',
            'padding': '6px 10px'
        }">
                           {{ invoice?.sesstatus || '--' }}
                        </span>
</td>
                    <td class="text-warning strong cursor-pointer" (click)="openInvoices(batchData, invoice)">{{'shipment.Viewdetails' | cxTranslate}}</td>
                </tr>
            </tbody>
        </table>
    </div>
   
    <div *ngIf="!portInvoices.length"
        class="empty-invoice-state text-center d-flex flex-column justify-content-center align-items-center flex-grow-1">
        <p class="empty-title mb-3">{{'shipment.invoice.NoInvoicesAttachedYet' | cxTranslate}}</p>
        <p class="text-secondary mb-3">{{'shipment.invoice.NoInvoicesAttachedYetMsg' | cxTranslate}}</p>
        <button class="btn btn-sm strong text-primary btn-light border rounded btnheight pl-5 pr-5 bg-transparent"
            (click)="openInvoices(batchData)">{{'shipment.invoice.attachInvoice' | cxTranslate}}</button>

    </div>
</div>
<div class="modal-footer">
    <div class="w-100 d-flex justify-content-between align-items-center">
        <div class="d-flex ml-auto">
            <button *ngIf="portInvoices.length" class="btn btn-sm strong btn-primary border rounded btnheight pl-5 pr-5"
                (click)="openInvoices(batchData)">{{'shipment.invoice.AddInvoice' |
                cxTranslate}}</button>
            <button class="btn btn-light action-btn ml-2" type="button" (click)="onClose()">{{'shipment.closetext' |
                cxTranslate}}</button>
        </div>
    </div>
</div>